// User-controlled in-app sound settings (toggle + volume).
// Persisted to localStorage so they survive reloads and apply across all chimes.

const ENABLED_KEY = "lr.sound.enabled";
const VOLUME_KEY = "lr.sound.volume"; // 0..1

export function getSoundEnabled(): boolean {
  if (typeof window === "undefined") return true;
  const v = window.localStorage.getItem(ENABLED_KEY);
  return v === null ? true : v === "1";
}

export function getSoundVolume(): number {
  if (typeof window === "undefined") return 0.6;
  const v = window.localStorage.getItem(VOLUME_KEY);
  const n = v == null ? 0.6 : parseFloat(v);
  if (!Number.isFinite(n)) return 0.6;
  return Math.min(1, Math.max(0, n));
}

export function setSoundEnabled(on: boolean) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(ENABLED_KEY, on ? "1" : "0");
  window.dispatchEvent(new CustomEvent("lr-sound-settings-changed"));
}

export function setSoundVolume(v: number) {
  if (typeof window === "undefined") return;
  const clamped = Math.min(1, Math.max(0, v));
  window.localStorage.setItem(VOLUME_KEY, String(clamped));
  window.dispatchEvent(new CustomEvent("lr-sound-settings-changed"));
}
